// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @20.11.2018 09:54:23
import { AlternateUserProfile_abstract } from './../abstract/SagaBase/AlternateUserProfile_abstract';
export class AlternateUserProfile extends AlternateUserProfile_abstract {}
